import React from 'react'

const DeliveryAndPayment = ({ color = '#676767' }: { color?: string }) => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.9999 8.5999V16.5999M7.3999 12.8907C3.88171 13.484 1.3999 14.9212 1.3999 16.5999C1.3999 18.809 5.69797 20.5999 10.9999 20.5999C16.3018 20.5999 20.5999 18.809 20.5999 16.5999C20.5999 14.9212 18.1181 13.484 14.5999 12.8907M14.1999 4.5999C14.1999 6.36721 12.7672 7.7999 10.9999 7.7999C9.23259 7.7999 7.7999 6.36721 7.7999 4.5999C7.7999 2.83259 9.23259 1.3999 10.9999 1.3999C12.7672 1.3999 14.1999 2.83259 14.1999 4.5999Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default DeliveryAndPayment
